import './SystemMessageItem.scss';

export { default } from './SystemMessageItem';
